import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { Language, LanguageMessage, messagesByLanguage } from '.';

type ContextProps = {
  language: Language;
  setLanguage: (value: Language) => void;
  messages: LanguageMessage;
};

const defaultContext: ContextProps = {
  language: 'fr',
  setLanguage: () => {},
  messages: messagesByLanguage['fr'],
};

const LanguageContext = createContext(defaultContext);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const storedLanguage = localStorage.getItem('selectedLanguage') as Language;
  const [language, setLanguage] = useState<Language>(storedLanguage || 'fr');
  const [messages, setMessages] = useState<LanguageMessage>(
    messagesByLanguage[language]
  );

  const value = {
    language,
    setLanguage,
    messages,
  };

  useEffect(() => {
    setMessages(messagesByLanguage[language]);
  }, [language]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
